import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "../..";
import useBreakpoints from "../../hooks/useBreakpoints";

interface ChartTableProps<T> {
  data: T[];
  labelAccessor: (item: T) => string;
  valueAccessor: (item: T) => string;
  colorAccessor: (item: T, index?: number) => string;
  labelHeader: string;
  valueHeader: string;
}

function ChartTable<T>(props: ChartTableProps<T>) {
  const {
    data,
    labelAccessor,
    valueAccessor,
    colorAccessor,
    labelHeader,
    valueHeader,
  } = props;

  const { mdUp } = useBreakpoints();

  return (
    <Table size="small" borderless={!mdUp} sidePadding={0}>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography
              variant="label1"
              color="grey"
              tone={600}
              fontWeight="bold"
            >
              {labelHeader}
            </Typography>
          </TableCell>
          <TableCell align="right">
            <Typography
              variant="label1"
              color="grey"
              tone={600}
              fontWeight="bold"
            >
              {valueHeader}
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item, index) => {
          return (
            <TableRow key={labelAccessor(item)}>
              <TableCell>
                <Typography
                  variant="body2"
                  component="span"
                  label="Total"
                  bullet
                  bulletColor={colorAccessor(item, index)}
                  color="grey"
                  tone={800}
                >
                  {labelAccessor(item)}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography
                  variant="h4"
                  fontWeight="semiBold"
                  component="span"
                  label="Growth"
                  noWrap
                  color="grey"
                  tone={900}
                >
                  {valueAccessor(item)}
                </Typography>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default ChartTable;
